import { BaseComponent } from '../core/BaseComponent.js';

export class Tabs extends BaseComponent {
    constructor(selector = '[data-tabs]', options = {}) {
        super(selector, options);
        this.selector = selector;
    }

    exists() {
        return document.querySelector(this.selector) !== null;
    }

    init() {

        console.log('test');
        this.bindEvents();
        return this;
    }

    bindEvents() {
        document.addEventListener('click', (e) => {
            const tabButton = e.target.closest('[data-tab]');
            if (!tabButton) return;

            const container = tabButton.closest(this.selector);
            if (!container) return;

            this.switchTab(container, tabButton);
        });
    }

    switchTab(container, tabButton) {
        const target = tabButton.getAttribute('data-tab');

        const buttons = container.querySelectorAll('[data-tab]');
        const contents = container.querySelectorAll('[data-tab-content]');

        // Remove active
        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));

        // Activate selected
        tabButton.classList.add('active');

        const activeContent = container.querySelector(
            `[data-tab-content="${target}"]`
        );

        if (activeContent) {
            activeContent.classList.add('active');
        }
    }
}